import type { ThemeManifest } from '../types';
import { Layout } from './Layout';
import { DashboardLayout } from './DashboardLayout';
import { PageHeader } from './PageHeader';

export const blazeTheme: ThemeManifest = {
  preset: 'blaze',
  displayName: 'BlazePOS',
  description: 'Default BlazePOS look — vertical sidebar, orange accent, rounded surfaces.',
  className: 'theme-blaze',
  components: {
    Layout,
    DashboardLayout,
    PageHeader,
  },
};
